module.exports = __webpack_public_path__ + "img/Shangtianjia.35236ce0.svg";